/* MONT DEGRÉS v1 : page collection A (20/10/2026). Chips de filtre immédiat (21/10 : rangée genre + rangée type / usage / zones, combinées), compteur, « Voir plus » par paquets,
   bande de marque gardée après le 4e produit visible (ordre CSS), tri Shopify par le menu, filtre pré-coché par l'ancre #f=z:21. */
(()=>{
  const root=document.querySelector('[data-md-cg]');if(!root)return;
  const pas=parseInt(root.dataset.pas,10)||12;
  const grid=root.querySelector('[data-md-cg-grid]');
  const items=[...grid.querySelectorAll('.md-cg__it')];
  const band=grid.querySelector('[data-md-cm]');
  const chips=[...root.querySelectorAll('.md-cg__chip')];
  const nEl=root.querySelector('[data-md-cg-n]'),uEl=root.querySelector('[data-md-cg-u]');
  const plus=root.querySelector('[data-md-cg-plus]'),vide=root.querySelector('[data-md-cg-vide]');
  const total=parseInt(nEl&&nEl.textContent,10)||items.length;
  /* 28/10 (Kilian : genre et type mieux distingués) : nombre de modèles de chaque puce calculé avec le filtre de l'AUTRE rangée (plus affiché, décision de Kilian) ; une puce à 0 disparaît
     (puces cachées d'origine, ex. 21 zones, laissées cachées) ; bande de confiance li.md-cg__conf placée comme la bande de marque. */
  const conf=grid.querySelector('.md-cg__conf');
  /* 01/11 (rangement des collections) : intertitres de famille et rail visibles en vue Tout seulement ; bande de marque après la première famille (data-md-cg-fin1), après 4 produits dès qu'un filtre agit */
  const fams=[...grid.querySelectorAll('[data-md-fam]')],rail=root.querySelector('[data-md-rail]'),fin1=parseInt(grid.dataset.mdCgFin1,10)||0;
  chips.forEach(c=>{if(c.hidden)c.dataset.mdCache='1'});
  /* 21/10 : deux rangées qui se combinent, « g » (genre) et « t » (type, usage ou zones) ; une chip vaut « clé:valeur » (z:21, t:gilet, g:h) */
  const etat={g:'',t:''};let montres=pas;
  const grp=c=>(c.closest('[data-grp]')||{}).dataset?.grp||'t';
  const ok=it=>Object.values(etat).every(f=>{if(!f)return true;const[k,v]=f.split(':');return !v||it.dataset[k]===v});
  const okSauf=(it,k)=>Object.entries(etat).every(([kk,f])=>{if(kk===k||!f)return true;const[a,v]=f.split(':');return !v||it.dataset[a]===v});
  const nbPour=(c,k)=>{const[a,v]=c.dataset.f.split(':');return items.filter(it=>okSauf(it,k)&&(!v||it.dataset[a]===v)).length};
  function compter(){
    if(src)return;
    chips.forEach(c=>{const n=nbPour(c,grp(c));if(!c.dataset.mdCache)c.hidden=n===0&&!c.classList.contains('is-on');});
  }
  function rendre(){
    const vis=items.filter(ok);
    items.forEach(it=>{it.hidden=true;it.style.order=''});
    vis.forEach((it,i)=>{it.style.order=String(i*2);if(i<montres)it.hidden=false});
    const tout=!etat.g&&!etat.t;
    fams.forEach(f=>{f.hidden=!tout;f.style.order=String(parseInt(f.dataset.i,10)*2-1)});
    if(rail)rail.hidden=!tout;
    if(band){band.style.order=String((tout&&fin1?fin1:Math.min(vis.length,4))*2-1);band.hidden=vis.length===0}
    if(conf){conf.style.order=String(Math.min(vis.length,4)*2-1);conf.hidden=vis.length===0}
    const n=(etat.g||etat.t)?vis.length:total;
    if(nEl)nEl.textContent=n;if(uEl)uEl.textContent=n>1?'modèles':'modèle';
    if(plus)plus.hidden=vis.length<=montres;
    if(vide)vide.hidden=vis.length>0;
    chips.forEach(c=>{const f=c.dataset.f,on=etat[grp(c)]===f||(!etat[grp(c)]&&/:$/.test(f));c.classList.toggle('is-on',on);c.setAttribute('aria-pressed',on)});
    compter();
  }
  /* 21/10 (brief v7) : collection de type (Vestes, Sweats, gants par usage…) : sélecteur de la source pré-coché, un autre choix renvoie vers la source */
  const top=root.querySelector('[data-md-cg-src]'),src=top&&top.dataset.mdCgSrc;
  const versUrl=(e,base)=>{const q=new URLSearchParams(base?location.search:'');q.delete('g');q.delete('t');q.delete('z');if(e.g)q.set('g',e.g.split(':')[1]);if(e.t){const[k,v]=e.t.split(':');q.set('t',k==='z'?v:(/^(veste|gilet|sweat|parka)$/.test(v)?v+'s':v))}const s=q.toString();return (base||src)+(s?'?'+s:'')};
  const annoncer=()=>document.dispatchEvent(new CustomEvent('md:cg-filtre',{detail:{...etat}}));
  function choisir(f,c,local){
    montres=pas;
    if(f==='*'){etat.g='';etat.t='';if(src&&!local){location.href=src;return}rendre();annoncer();return}
    c=c||chips.find(x=>x.dataset.f===f);if(!c)return;
    const g=grp(c);c.hidden=false;
    const suite={...etat};suite[g]=(etat[g]===f||/:$/.test(f))?'':f;
    if(src&&!local){location.href=versUrl(suite);return}
    etat.g=suite.g;etat.t=suite.t;
    if(!src&&etat.t&&!items.some(it=>ok(it)))etat.t='';
    if(!src&&!local)history.replaceState(null,'',versUrl(etat,location.pathname)+location.hash);
    if(!src)rendre();else chips.forEach(c=>{const f=c.dataset.f,on=etat[grp(c)]===f||(!etat[grp(c)]&&/:$/.test(f));c.classList.toggle('is-on',on);c.setAttribute('aria-pressed',on)});
    annoncer();
  }
  if(src&&top.dataset.mdCgInit)top.dataset.mdCgInit.split(' ').forEach(f=>choisir(f,null,true));
  root.addEventListener('click',e=>{
    const b=e.target.closest('[data-f]');if(b){choisir(b.dataset.f,b.classList.contains('md-cg__chip')?b:null);return}
    if(e.target.closest('[data-md-cg-plus]')){montres+=pas;rendre()}
  });
  const sel=root.querySelector('[data-md-cg-sort]');
  if(sel)sel.addEventListener('change',()=>{const u=new URL(location.href);u.searchParams.set('sort_by',sel.value);u.searchParams.delete('page');u.hash='';location.href=u.toString()});
  /* Pré-réglage : paramètres de requête ?g=h|f|e et ?t=vestes|gilets|sweats|parkas|ski|moto|velo|ville|21|11, ?z=21|11 (URL finales Google Ads), ancre #f=g:h en repli */
  const lire=defile=>{
    const f=[...location.hash.matchAll(/f=([a-z]:\w+)/g)].map(x=>x[1]);
    const q=new URLSearchParams(location.search),g=q.get('g'),t=(q.get('t')||'').toLowerCase().replace(/s$/,'');
    if(g)f.push('g:'+g.toLowerCase().charAt(0));
    if(t)f.push(/^\d+$/.test(t)?'z:'+t:'t:'+t);
    const z=q.get('z');if(z)f.push('z:'+z);
    if(!f.length)return;
    etat.g='';etat.t='';f.forEach(x=>choisir(x,null,true));
    if(defile)root.scrollIntoView({block:'start'});
  };
  window.addEventListener('hashchange',()=>lire(true));
  if(!src)lire(location.hash.includes('f='));
  compter();
})();
/* 20/10 (complément au brief v2) : bandes de messages des cartes, un message toutes les 2,5 s, fondu 350 ms, départ décalé au hasard (0 à 600 ms) ;
   rien ne tourne sous prefers-reduced-motion (premier message fixe), ni hors écran. */
(()=>{
  const bandes=[...document.querySelectorAll('.md-cg__strip[data-m]')];
  if(!bandes.length||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  const vues=new Set();
  const io='IntersectionObserver' in window?new IntersectionObserver(es=>es.forEach(e=>e.isIntersecting?vues.add(e.target):vues.delete(e.target))):null;
  bandes.forEach(b=>{
    const m=b.dataset.m.split('|').filter(Boolean);if(m.length<2)return;
    const i=b.querySelector('i');let k=0;
    if(io)io.observe(b);else vues.add(b);
    setTimeout(()=>setInterval(()=>{
      if(!vues.has(b)||document.hidden)return;
      i.classList.add('is-out');
      setTimeout(()=>{k=(k+1)%m.length;i.textContent=m[k];i.classList.remove('is-out')},350);
    },2500),Math.random()*600);
  });
})();
/* 21/10 (brief v7) : l'intro de l'en-tête suit la puce de type ou le segment d'usage actif (fondu 200 ms) ; sans réglage, l'intro de la collection */
(()=>{
  const p=document.querySelector('[data-md-ch-ph]');if(!p)return;
  p.style.transition='opacity .2s';
  const maj=f=>{
    const t=(f||'').split(':');const cle=t[0]==='t'?t[1]:'';
    const txt=(cle&&p.dataset['i'+cle.charAt(0).toUpperCase()+cle.slice(1)])||p.dataset.base;
    if(p.textContent===txt)return;
    p.style.opacity='0';setTimeout(()=>{p.textContent=txt;p.style.opacity='1'},200);
  };
  document.addEventListener('md:cg-filtre',e=>maj(e.detail.t));
  const on=document.querySelector('[data-grp="t"] .md-cg__chip.is-on');if(on)maj(on.dataset.f);
})();
